var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('NavTopAppBar'),_c('div',{attrs:{"id":"app"}},[_c('v-container',{attrs:{"fluid":""}},[_c('NavSideBarDrawer'),_c('router-view')],1),_c('MessageSnackBar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }